import { useContext } from 'react';
import { useTreatments, SplitContext } from '@splitsoftware/splitio-react';

export const useSplit = (splitName: string) => {
  const { isReady } = useContext(SplitContext);

  const treatments = useTreatments([splitName]);

  const { treatment } = treatments[splitName];

  const isActive = treatment === 'on';

  return {
    isActive,
    isReady,
  };
};
